import { render, staticRenderFns } from "./BookingsCard.vue?vue&type=template&id=78a800c0&"
import script from "./BookingsCard.vue?vue&type=script&lang=js&"
export * from "./BookingsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports